/* eslint-disable no-param-reassign */
import {
  FETCH_PORTLIST_LOADING,
  FETCH_PORTLIST_DONE,
  FETCH_PORTLIST_ERROR,
  FETCH_AVAILABLE_LINES_LOADING,
  FETCH_AVAILABLE_LINES_DONE,
  FETCH_AVAILABLE_LINES_ERROR,
  FETCH_VESSELSCHEDULE_LOADING,
  FETCH_VESSELSCHEDULE_DONE,
  FETCH_VESSELSCHEDULE_ERROR,
  SEND_REQ_QUOTA_LOADING,
  SEND_REQ_QUOTA_DONE,
  SEND_REQ_QUOTA_ERROR
} from './actions'

export default {
  [FETCH_PORTLIST_LOADING] (state) {
    state.isLoadingPortList = true
  },
  [FETCH_PORTLIST_DONE] (state, items) {
    state.portList = items
    state.isLoadingPortList = false
  },
  [FETCH_PORTLIST_ERROR] (state, error) {
    state.errorPortList = error
    state.isLoadingPortList = false
  },

  [FETCH_AVAILABLE_LINES_LOADING] (state) {
    state.isLoadingAvailableLines = true
  },
  [FETCH_AVAILABLE_LINES_DONE] (state, items) {
    state.availableLines = items
    state.isLoadingAvailableLines = false
  },
  [FETCH_AVAILABLE_LINES_ERROR] (state, error) {
    state.errorAvailableLines = error
    state.isLoadingAvailableLines = false
  },

  [FETCH_VESSELSCHEDULE_LOADING] (state) {
    state.isLoadingDataVesselSchedule = true
  },
  [FETCH_VESSELSCHEDULE_DONE] (state, items) {
    state.dataVesselSchedule = items
    state.isLoadingDataVesselSchedule = false
  },
  [FETCH_VESSELSCHEDULE_ERROR] (state, error) {
    state.errorDataVesselSchedule = error
    state.isLoadingDataVesselSchedule = false
  },

  [SEND_REQ_QUOTA_LOADING] (state) {
    state.isLoadingRequestQuota = true
  },
  [SEND_REQ_QUOTA_DONE] (state, items) {
    state.requestQuota = items
    state.isLoadingRequestQuota = false
  },
  [SEND_REQ_QUOTA_ERROR] (state, error) {
    state.errorRequestQuota = error
    state.isLoadingRequestQuota = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vessel-schedule/mutations.js